/* eslint-disable react/jsx-handler-names */
/**
 * @fileOverview The main entry point to your standalone. Start editing here.
 */

import React from 'react'
import '@ta-interaktiv/semantic-ui/semantic/dist/components/reset.css'
import '@ta-interaktiv/semantic-ui/semantic/dist/components/site.css'
import '@ta-interaktiv/semantic-ui/semantic/dist/components/segment.css'
import '@ta-interaktiv/semantic-ui/semantic/dist/components/container.css'
import '@ta-interaktiv/semantic-ui/semantic/dist/components/header.css'
import '@ta-interaktiv/semantic-ui/semantic/dist/components/image.css'
import '@ta-interaktiv/semantic-ui/semantic/dist/components/list.css'
import '@ta-interaktiv/semantic-ui/semantic/dist/components/grid.css'
import '@ta-interaktiv/semantic-ui/semantic/dist/components/dropdown.css'
import './styles.scss'
import { Masthead } from '@ta-interaktiv/react-masthead'
import { Footer } from '@ta-interaktiv/react-footer'
import { ThemeSwitch } from '@ta-interaktiv/react-theme-switch'
import { browserCheck } from '@ta-interaktiv/browsercheck'
import { MunicipalitySearch } from '@ta-interaktiv/react-municipality-search'
import { SwissMap } from '@ta-interaktiv/react-swissmap'
import { ActiveMunicipality } from './active-municipality'

import { Dropdown } from 'semantic-ui-react'
import { RankingTable } from './ranking-table'
import { ColorLegend } from './color-legend'
import * as d3 from 'd3'
import { thousandsSeparators } from 'lib/thousandsSeperator'

const isMobile = browserCheck.isMobile

// GET PARAMS FROM URL
const params = new URL(window.location).searchParams
const municipalityPreselect = {
  GDENR: parseInt(params.get('commune'))
}

const ARTICLE_ID = '845129260356'
const taxSubjects = [
  'Célibataire, 0 enfants',
  'Célibataire, 1 enfant',
  'Célibataire, 2 enfants',
  'Célibataire, 3 enfants',
  'Marié·e, un revenu, 0 enfants',
  'Marié·e, un revenu, 1 enfant',
  'Marié·e, un revenu, 2 enfants',
  'Marié·e, un revenu, 3 enfants',
  'Marié·e, deux revenus (70/30), 0 enfants',
  'Marié·e, deux revenus (70/30), 1 enfant',
  'Marié·e, deux revenus (70/30), 2 enfants',
  'Marié·e, deux revenus (70/30), 3 enfants',
  'Marié·e, deux revenus (50/50), 0 enfants',
  'Marié·e, deux revenus (50/50), 1 enfant',
  'Marié·e, deux revenus (50/50), 2 enfants',
  'Marié·e, deux revenus (50/50), 3 enfants',
  'Retraité·e, célibataire',
  'Marié·e, une retraite',
  'Marié·e, deux retraites (70/30)',
  'Marié·e, deux retraites (50/50)'
]
const availableIncome = [
  { text: "15'000", value: 15000 },
  { text: "20'000", value: 20000 },
  { text: "25'000", value: 25000 },
  { text: "30'000", value: 30000 },
  { text: "35'000", value: 35000 },
  { text: "40'000", value: 40000 },
  { text: "45'000", value: 45000 },
  { text: "50'000", value: 50000 },
  { text: "60'000", value: 60000 },
  { text: "70'000", value: 70000 },
  { text: "80'000", value: 80000 },
  { text: "90'000", value: 90000 },
  { text: "100'000", value: 100000 },
  { text: "125'000", value: 125000 },
  { text: "150'000", value: 150000 },
  { text: "175'000", value: 175000 },
  { text: "200'000", value: 200000 },
  { text: "250'000", value: 250000 },
  { text: "300'000", value: 300000 },
  { text: "400'000", value: 400000 },
  { text: "500'000", value: 500000 },
  { text: "750'000", value: 750000 },
  { text: '1 Million', value: 1000000 },
  { text: '5 Millions', value: 5000000 },
  { text: '10 Millions', value: 10000000 },
  { text: '50 Millions', value: 50000000 },
  { text: '100 Millions', value: 100000000 }
]

const colorPalette = ['#296b8e', 'lightgrey', '#9e272f']

const introSentences = {
  heaven:
    'fait partie des communes à la fiscalité la plus avantageuse du canton.',
  earth: 'a une charge fiscale dans la moyenne cantonale.',
  hell: 'compte l’une des charges fiscales les plus lourdes du canton.'
}
function capitalizeFirstLetter(str) {
  return str.charAt(0).toUpperCase() + str.slice(1)
}
export class AppComponent extends React.Component {
  ToolTip = ({ activeData }) => {
    let cantonInName = ''
    const cantonPattern = /\([A-Z][A-Z]\)/
    if (activeData) {
      cantonInName = activeData.GemeindenameFR.match(cantonPattern)
    }

    return (
      <>
        {activeData ? (
          <div className='ui raised compact segment inner-tooltip'>
            <div>
              <div className='municipality-name'>
                {activeData.GemeindenameFR}{' '}
                {!cantonInName ? '(' + activeData.Kanton + ')' : ''}
              </div>
              <div className='percentage'>
                Charge:
                <span className='number'>{activeData.Belastung + '%'}</span>
              </div>
              <div className='amount'>
                Impôt dû:
                <span className='number'>
                  {thousandsSeparators(
                    (
                      (activeData.Belastung / 100) *
                      this.state.selectedIncome
                    ).toFixed(2)
                  ) + ' CHF'}
                </span>
              </div>
              <div className='rank'>
                Rang <span>{thousandsSeparators(activeData.Rank)}</span>/
                {this.state.lastRank}
              </div>
            </div>
          </div>
        ) : (
          <div className='ui raised compact segment inner-tooltip'>
            <div>Keine Daten vorhanden</div>
          </div>
        )}
      </>
    )
  }

  constructor() {
    super()
    this.state = {
      preselectedMunicipality: undefined,
      activeMunicipality: undefined,
      searchToggle: -1,
      municipalityData: undefined,
      taxMinValue: 1,
      taxMaxValue: 2,
      selectedTaxSubject: 15,
      selectedIncome: 150000,
      colorFunction: undefined,
      selectedAutoText: undefined,
      lastRank: 2206
    }
    this.preselectMunicipality = this.preselectMunicipality.bind(this)
  }

  componentDidMount() {
    this.fetchData()
  }

  componentDidUpdate = (_prevProps, prevState) => {
    if (
      prevState.selectedTaxSubject !== this.state.selectedTaxSubject ||
      prevState.selectedIncome !== this.state.selectedIncome
    ) {
      this.fetchData(prevState?.activeMunicipality?.bfsId)
    }
  }

  preselectMunicipality(preselection) {
    this.setState(
      {
        preselectedMunicipality: this.state.municipalityData.find(
          muni => +muni.bfsId === +preselection.GDENR
        )
      },
      function() {
        const lang = 'fr'
        fetch(
          'https://interaktiv.tagesanzeiger.ch/2022/steuerparadies/auto-text/autotext_2021_15_150000_' +
            lang +
            '.json'
        ).then(res => {
          res.json().then(rawData => {
            if (this.state.preselectedMunicipality) {
              this.setState({
                selectedAutoText: rawData.find(
                  autoTextObj =>
                    +autoTextObj.bfsid ===
                    +this.state.preselectedMunicipality.bfsId
                )
              })
            }
          })
        })
      }
    )
    if (this.state.activeMunicipality === undefined) {
      this.setState({
        activeMunicipality: this.state.municipalityData.find(
          muni => +muni.bfsId === +preselection.GDENR
        )
      })
    }
  }

  fetchData = prevActiveBfsId => {
    fetch(
      'https://interaktiv.tagesanzeiger.ch/2022/steuerparadies/steuerbelastung-data/2021_' +
        this.state.selectedTaxSubject +
        '_' +
        this.state.selectedIncome +
        '.json'
    ).then(res => {
      res.json().then(rawData => {
        const formattedData = rawData

        formattedData.municipalities = rawData.municipalities.map(
          municipality => {
            municipality.bfsId = municipality.index
            delete municipality.index // Delete old key
            return municipality
          }
        )
        this.setState({
          municipalityData: formattedData.municipalities,
          taxMinValue: formattedData.extent[0],
          taxMaxValue: formattedData.extent[1],
          lastRank: Math.max(
            ...formattedData.municipalities.map(muni => muni.Rank)
          ),
          colorFunction: d3
            .scaleLinear()
            .domain([
              formattedData.extent[0],
              (formattedData.extent[0] + formattedData.extent[1]) / 2,
              formattedData.extent[1]
            ])
            .range(colorPalette)
        })
        if (prevActiveBfsId) {
          this.setState({
            activeMunicipality: formattedData.municipalities.find(
              muni => muni.bfsId === prevActiveBfsId
            )
          })
        }
        if (this.state.preselectedMunicipality === undefined) {
          this.preselectMunicipality(municipalityPreselect)
        }
      })
    })
  }

  render() {
    console.log(this.state)

    return (
      <div className='index'>
        <Masthead articleId={ARTICLE_ID} />
        <ThemeSwitch />

        <header className='ui vertical  very fitted  segment'>
          <div className='ui container'>
            <div className='ui header'>
              {!this.state.preselectedMunicipality && (
                <>
                  <h1>Où se situe votre paradis fiscal? </h1>
                  <h2>
                    Alors que les hauts revenus sont le moins imposés à Schwyz,
                    c'est à Baar que la classe moyenne paie le moins. Seulement
                    un septième de ce qui est ponctionné à Enges, dans le canton
                    de Neuchâtel.
                  </h2>
                </>
              )}
              {this.state.preselectedMunicipality &&
                this.state.selectedAutoText && (
                  <>
                    <h1>
                      {/* {titleSentences[this.state.selectedAutoText.hellorheaven]}
                      {this.state.selectedAutoText.namemunicipality} */}
                      {this.state.selectedAutoText.hellorheaven === 'heaven'
                        ? 'Les familles ' +
                          this.state.selectedAutoText
                            .namemunicipalityarticlede +
                          ' paient plutôt peu d’impôts'
                        : this.state.selectedAutoText.hellorheaven === 'earth'
                        ? 'Voici vos impôts si vous habitez ' +
                          this.state.selectedAutoText.namemunicipalityarticlea
                        : this.state.selectedAutoText.namemunicipality +
                          ' a un taux d’imposition élevé'}
                    </h1>
                    <h2>
                      {capitalizeFirstLetter(
                        this.state.selectedAutoText.taxheavenincanton
                      )}{' '}
                      on paie le moins,{' '}
                      {this.state.selectedAutoText.taxhellincanton} le plus:
                      voici, commune par commune, comment est distribuée la
                      fiscalité{' '}
                      {this.state.selectedAutoText.namecantonfrarticledefini}.{' '}
                      {this.state.selectedAutoText.hellorheaven === 'earth' ? (
                        <>
                          {capitalizeFirstLetter(
                            this.state.selectedAutoText.namemunicipality
                          )}{' '}
                          se situe entre les deux. Testez notre comparaison
                          cantonale.
                        </>
                      ) : (
                        <>
                          Découvrez où vous devriez payer moins d’impôts et où
                          vous devriez en payer plus.{' '}
                        </>
                      )}
                    </h2>
                  </>
                )}
            </div>
          </div>
        </header>

        <div className='ui vertical segment'>
          <div className='ui text container'>
            <div className='ta metainfo'>
              <div className='ta author'>
                Iwan Städler, Dariush Mehdiaraghi, Timo Grossenbacher, Mathias
                Lutz, Jonas Liniger
              </div>
              <div className='ta updated'>Mis à jour le 10 février 2022</div>
            </div>
            <div className='ta text' style={{ marginBottom: '1em' }}>
              <p>
                Comparer peut s’avérer utile et pas seulement pour les
                millionnaires. Même pour les salaires les plus bas, la charge
                fiscale varie fortement selon le lieu de résidence. Dans les cas
                extrêmes, un déménagement permet d'économiser plus de 80% en
                impôts.
              </p>
            </div>
          </div>

          {this.state.preselectedMunicipality && this.state.selectedAutoText && (
            <div className='ui container ta dynamic text'>
              <p>
                <span className='accent'>
                  {this.state.selectedAutoText.namemunicipality}
                </span>{' '}
                {introSentences[this.state.selectedAutoText.hellorheaven]} Les
                couples salariés avec enfants avec deux enfants avec un revenu
                total de 150 000 francs par an paient{' '}
                <span className='accent'>
                  {this.state.selectedAutoText.taxloadrelativeformunicipality}%
                </span>{' '}
                de leur revenu annuel en impôts, ce qui correspond à{' '}
                <span className='accent'>
                  {thousandsSeparators(
                    this.state.selectedAutoText.taxloadabsoluteformunicipality
                  )}{' '}
                  francs.
                </span>{' '}
                Cela place {this.state.selectedAutoText.namemunicipality} au{' '}
                <span className='accent'>
                  {thousandsSeparators(
                    this.state.selectedAutoText.ranktaxloadabsolutecantonal
                  )}
                  <sup>
                    {this.state.selectedAutoText.ranktaxloadabsolutecantonal ===
                    1
                      ? 'er'
                      : 'e'}
                  </sup>{' '}
                  rang des{' '}
                  {this.state.selectedAutoText.countmunicipalitiesincanton}
                </span>{' '}
                des communes les plus avantageuses sur le plan fiscal{' '}
                {this.state.selectedAutoText.namecantonfrarticledefini}.{' '}
                {+this.state.selectedAutoText.ranktaxloadabsolutecantonal !==
                  1 && (
                  <>
                    Le «paradis» fiscal{' '}
                    {this.state.selectedAutoText.cantonadjectiffrmasc} se trouve{' '}
                    {this.state.selectedAutoText.taxheavenincanton}, où une
                    famille avec le niveau de revenu décrit plus haut ne
                    paierait que{' '}
                    {thousandsSeparators(
                      this.state.selectedAutoText.taxloadabsoluteforheaven
                    )}{' '}
                    francs d'impôts.{' '}
                  </>
                )}
                {this.state.selectedAutoText.ranktaxloadabsolutecantonal !==
                  this.state.selectedAutoText.countmunicipalitiesincanton && (
                  <>
                    L'«enfer» fiscal du canton se trouve en revanche{' '}
                    {this.state.selectedAutoText.taxhellincanton}, où la famille
                    devrait payer{' '}
                    {thousandsSeparators(
                      this.state.selectedAutoText.taxloadabsoluteforhell
                    )}{' '}
                    francs d'impôts.
                  </>
                )}
              </p>
            </div>
          )}

          <div className='ui text container'>
            <div className='ta text'>
              <p>
                Mais attention: ce paradis fiscal n’est pas le même pour tout le
                monde. Selon le revenu et le type de ménage, une autre commune
                sera plus avantageuse. Grâce à notre carte interactive,
                découvrez en quelques clics où vous payeriez le moins d'impôts.
                Choisissez entre 20 types de ménages différents et 27 classes de
                revenus – et vous aurez une vue d'ensemble de la charge fiscale
                qui s’applique dans toutes les communes suisses.
              </p>
            </div>

          </div>
        </div>

        <div
          className='ui vertical grey segment'
          style={{ position: 'inherit' }}
        >
          <div className='ui graphic container'>
            <h3>Où se trouve votre paradis fiscal?</h3>
            <div
              className='ui stackable two column grid'
              style={{ marginBottom: '0.8em' }}
            >
              <div className='column'>
                <label htmlFor='taxSubject'>
                  Choisissez le modèle de calcul
                </label>
                {/* TODO: format number from 10000 to 10'000 */}
                <Dropdown
                  name='taxSubject'
                  id='taxSubject'
                  value={this.state.selectedTaxSubject}
                  fluid
                  selection
                  onChange={(event, item) => {
                    this.setState({ selectedTaxSubject: item.value })
                  }}
                  options={taxSubjects.map((taxSubject, index) => ({
                    key: taxSubject,
                    text: taxSubject,
                    value: index + 1
                  }))}
                />
              </div>
              <div className='column'>
                <label htmlFor='income'>et le revenu annuel brut en CHF</label>
                <Dropdown
                  name='income'
                  id='income'
                  value={this.state.selectedIncome}
                  fluid
                  selection
                  onChange={(event, item) => {
                    this.setState({ selectedIncome: item.value })
                  }}
                  options={availableIncome.map((income, index) => ({
                    key: index,
                    text: income.text + ' CHF',
                    value: income.value
                  }))}
                />
              </div>
            </div>
            <div className={isMobile ? '' : 'ui container float-above'}>
              <div className={isMobile ? '' : 'municipality-search-wrapper'}>
                <div className='input-wrapper'>
                  <label htmlFor='search'>Trouver une commune</label>
                  <MunicipalitySearch
                    municipalityData='20200101'
                    locale='fr'
                    dedupe
                    hideTooltip
                    resetOnSelect
                    placeholder='Nom de la commune'
                    showLastSelectedMunicipalities={true}
                    numberOfLastSelectedMunicipalities={1}
                    onSelectionHandler={selectedMunicipality => {
                      if (this.state.municipalityData) {
                        this.setState({
                          activeMunicipality: this.state.municipalityData.find(
                            muni => +muni.bfsId === +selectedMunicipality.GDENR
                          )
                        })
                      }
                    }}
                  />
                </div>
                {!isMobile && this.state.activeMunicipality && (
                  <ActiveMunicipality
                    activeMunicipality={this.state.activeMunicipality}
                    selectedIncome={this.state.selectedIncome}
                    lastRank={this.state.lastRank}
                  />
                )}
              </div>
            </div>
            {/* <ToolTip /> */}
            {this.state.municipalityData && (
              <SwissMap
                propertyNameToCompare='Belastung'
                municipalityData={this.state.municipalityData}
                minValue={this.state.taxMinValue}
                maxValue={this.state.taxMaxValue}
                municipalitySearchYear='20200101'
                hideMunicipalitySearch
                colorPalette={colorPalette}
                topoJsonYear={2020}
                activeMunicipalityId={
                  this.state.activeMunicipality?.bfsId || false
                }
                hoverHandler={newData => {
                  // console.log(newData)
                }}
                newActiveMunicipalityIdHandler={newId => {
                  this.setState({
                    activeMunicipality: this.state.municipalityData.find(
                      muni => +muni.bfsId === +newId
                    )
                  })
                }}
                ToolTip={this.ToolTip}
                activeStrokeWidth={isMobile ? '4' : '2'}
              />
            )}
            {this.state.taxMaxValue && (
              <div className='ui text container'>
                <ColorLegend
                  colorPalette={colorPalette}
                  minVal={this.state.taxMinValue}
                  maxVal={this.state.taxMaxValue}
                  currentValue={this.state.activeMunicipality?.Belastung}
                />
              </div>
            )}
            {isMobile && this.state.activeMunicipality && (
              <ActiveMunicipality
                activeMunicipality={this.state.activeMunicipality}
                selectedIncome={this.state.selectedIncome}
                lastRank={this.state.lastRank}
              />
            )}
          </div>
          {this.state.municipalityData && (
            <div className={'ui text ' + (isMobile ? '' : 'container')}>
              <RankingTable
                municipalityData={this.state.municipalityData}
                colorPalette={colorPalette}
                minValue={this.state.taxMinValue}
                maxValue={this.state.taxMaxValue}
                activeMunicipalityId={
                  this.state.activeMunicipality?.bfsId || false
                }
                onSelectionHandler={newId =>
                  this.setState({
                    activeMunicipality: this.state.municipalityData.find(
                      muni => +muni.bfsId === +newId
                    )
                  })
                }
              />
            </div>
          )}
        </div>

        <div className='ui vertical segment'>
          <div className='ui text container'>
            <div className='ta text'>
              <p>
                Les données sont officielles. L'Administration fédérale des
                contributions les a rendues accessibles il y a quelques jours{' '}
                <a
                  href='https://swisstaxcalculator.estv.admin.ch/#/taxburden/income-wealth-tax'
                  target='_blank'
                  className='cbLink cB'
                  rel='noreferrer'
                >
                  pour la période fiscale 2021.
                </a>{' '}
                À quoi faut-il faire attention? Et quelles sont les conclusions
                les plus intéressantes? Nos réponses à 11 questions.
              </p>

              <div className='CrossheadElement'>
                <div className='num'>1</div>
                <h4>
                  Concrètement, quelles sont les différences entre les
                  différents lieux de résidence?
                </h4>
              </div>
              <p className='ta text'>
                Les différences sont très grandes. Prenons une famille avec deux
                enfants, dont chacun des parents gagne la moitié du revenu brut
                de 150 000 francs. Dans les communes neuchâteloises d'Enges et
                des Verrières, cette famille doit verser au fisc 14,18% de son
                revenu. Si elle déménage à Baar, dans le canton de Zoug, ce taux
                n'est plus que de 2,16%. En changeant de domicile, la famille
                réduirait donc ses impôts d'environ 85%, avec une économie de
                18'000 francs. Dans la même situation, déménager de Lausanne à
                Lutry, jusute à côté, permettrait une économie de quelque 500
                francs.
              </p>

              <div className='CrossheadElement'>
                <div className='num'>2</div>
                <h4>Qu'en est-il des hauts salaires?</h4>
              </div>
              <p className='ta text'>
                Pour eux, les économies sont encore plus importantes, car les
                montants en jeu sont plus élevés. Parfois, «fuir» dans un
                paradis fiscal permet d'économiser des centaines de milliers de
                francs.
              </p>

              <div className='CrossheadElement'>
                <div className='num'>3</div>
                <h4>
                  La commune de Baar est-elle aussi la moins chère pour les
                  hauts revenus?
                </h4>
              </div>
              <p className='ta text'>
                Non, c’est dans la canton de Schwytz, plus précisément dans les
                communes de Feusisberg, Freienbach et Wollerau, que les revenus
                les plus élevés sont le moins imposés. Selon le type de ménage,
                ces trois communes sont les plus avantageuses à partir d'un
                revenu annuel de 250'000 à 5 millions de francs. Une famille à
                double revenu avec deux enfants et 5 millions de francs de
                revenu brut annuel doit y verser 983'000 francs au fisc, soit
                1'035'000 francs de moins qu'avec le même revenu dans la commune
                genevoise d'Avully. Dans ce cas précis, déménager peut donc
                valoir la peine. Et pour 2021, les impôts dans le canton de
                Schwyz seront même encore plus bas. Le Grand Conseil a en effet
                baissé le taux d'imposition d'un cinquième en décembre dernier.
              </p>

              <div className='CrossheadElement'>
                <div className='num'>4</div>
                <h4>
                  Où les personnes à faibles revenus paient-elles le moins
                  d'impôts?
                </h4>
              </div>
              <p className='ta text'>
                Dans de nombreux endroits. De nombreux cantons et communes
                laissent les très bas revenus non imposés. Pour ces ménages, la
                charge fiscale est donc de 0%.
              </p>

              <div className='CrossheadElement'>
                <div className='num'>5</div>
                <h4>Qui épargne les pauvres et «saigne» les riches?</h4>
              </div>
              <p className='ta text'>
                Le canton de Genève est avantageux pour la classe moyenne
                inférieure, mais il taxe fortement les hauts revenus.
              </p>

              <div className='CrossheadElement'>
                <div className='num'>6</div>
                <h4>Qui «saigne» les pauvres et épargne les riches?</h4>
              </div>
              <p className='ta text'>
                Tout d'abord: aucun canton ni aucune commune ne taxe davantage
                les personnes les plus pauvres que celles avec les plus hauts
                revenus. Cela serait contraire à la Constitution. Mais en
                comparaison avec d'autres cantons, Appenzell Rhodes-Intérieures
                est très favorable aux riches et coûte cher aux pauvres. Zoug,
                quant à lui, est avantageux pour toutes les catégories de
                revenus. Et Berne est cher pour la plupart des gens. En Suisse
                romande, ce sont les cantons de Fribourg et du Valais qui sont
                les plus favorables aux riches.
              </p>

              <div className='CrossheadElement'>
                <div className='num'>7</div>
                <h4>
                  Les paradis fiscaux sont-ils également attractifs pour les
                  personnes à faibles revenus?
                </h4>
              </div>
              <p className='ta text'>
                Non. Il est certes possible que les personnes à faible revenu
                économisent quelques francs en termes d’impôts en s'installant
                dans un paradis fiscal. Mais le loyer pèse bien plus lourd dans
                la balance pour les classes de revenus inférieures. Si l'on
                tient compte des frais de logement, un paradis fiscal peut
                s'avérer assez cher. Pour les bas revenus, les enfers fiscaux
                sont donc souvent plus avantageux au bout du compte. Car là où
                les impôts sont élevés, les loyers sont généralement bas – et
                inversement.
              </p>

              <div className='CrossheadElement'>
                <div className='num'>8</div>
                <h4>
                  Quels sont les impôts pris en compte? Et lesquels ne le sont
                  pas?
                </h4>
              </div>
              <p className='ta text'>
                Il s'agit ici de l'impôt sur le revenu, qui représente la
                majeure partie de la charge fiscale pour la plupart des ménages.
                Nos chiffres comprennent aussi bien les impôts sur le revenu de
                la Confédération que ceux du canton et de la commune. En
                revanche, les éventuels impôts ecclésiastiques ne sont pas
                inclus, car ils dépendent de la confession. L'impôt sur la
                fortune et les autres impôts et taxes ne sont pas non plus pris
                en compte.
              </p>

              <div className='CrossheadElement'>
                <div className='num'>9</div>
                <h4>
                  Qu'en est-il des déductions que je peux faire dans ma
                  déclaration d'impôts? Sont-elles prises en compte?
                </h4>
              </div>
              <p className='ta text'>
                Toutes les déductions légales pour lesquelles il n'est pas
                nécessaire de fournir de justificatif ont été prises en compte.
                En revanche, les déductions qui dépendent du montant des frais
                effectifs ne sont pas prises en compte. Comme elles varient d'un
                ménage à l'autre, elles ne sont pas prises en compte dans le
                calcul. Par conséquent, votre charge fiscale individuelle peut
                différer du résultat présenté ici. Mais cela ne joue pas un
                grand rôle dans la comparaison entre les différentes communes.
              </p>

              <div className='CrossheadElement'>
                <div className='num'>10</div>
                <h4>
                  Ces dernières années, ce journal proposait déjà un aperçu des
                  charges fiscales. Qu'est-ce qui est nouveau?
                </h4>
              </div>
              <p className='ta text'>
                Jusqu'à présent, la charge fiscale ne pouvait être déterminée
                que de manière rudimentaire pour cinq types de ménages.
                Désormais, la Confédération met à disposition beaucoup plus de
                données. Grâce à 20 types de ménages et 27 classes de revenus,
                il est désormais plus facile de calculer approximativement sa
                propre charge fiscale. Avec plus de 2000 communes, cela donne
                plus d'un million de charges fiscales différentes que vous
                pouvez comparer entre elles.
              </p>

              <div className='CrossheadElement'>
                <div className='num'>11</div>
                <h4>Quelle est la charge fiscale la plus élevée?</h4>
              </div>
              <p className='ta text'>
                46%. C'est ce que devrait payer un retraité avec un revenu de
                100 millions de francs dans la commune genevoise d'Avully. Mais
                un retraité n'atteint guère un revenu de 100 millions. Et s'il
                le faisait, il ne résiderait certainement pas à Avully.
              </p>
            </div>
          </div>
        </div>

        <Footer
          mailTo='interactif@tamedia.ch'
          locale='fr'
          articleId={ARTICLE_ID}
          hidePortfolioTeaser
          questions={[
            'À quel point était-elle informative?',
            'La réalisation technique a-t-elle fonctionné?',
            'Que pensez-vous de la présentation?'
          ]}
          credits={[
            ['Texte et analyse', 'Iwan Städler'],
            [
              'Conception et réalisation',
              'Dariush Mehdiaraghi et Mathias Lutz, Interaktiv-Team'
            ],
            ['Préparation des données', 'Jonas Liniger et Timo Grossenbacher'],
            [
              'Source',
              '<a href="https://swisstaxcalculator.estv.admin.ch/#/taxburden/income-wealth-tax" target="_blank">Administration fédérale des contributions</a>'
            ]
          ]}
        />
      </div>
    )
  }
}
